import ProgressCircle from '../../../../../components/features/ProgressCircle/ProgressCircle';

interface ProgressProps {
  progress?: number;
  status?: string;
}

const Progress = ({ progress = 0 }: ProgressProps) => {
  // Use default Cadence blue color
  const cadenceBlue = '#1d64f3';

  return (
    <div className="flex items-center justify-center p-1">
      <ProgressCircle
        progress={progress}
        size={36}
        strokeWidth={3}
        color={cadenceBlue}
        showPercentage={true}
      />
    </div>
  );
};

export default Progress;